import React from 'react'

import Height from './Height'
import Length from './Length'

interface Props {
  children?: React.ReactNode
  height?: number
  length?: number
}

const Dimensions: React.FC<Props> = ({ children, height, length }) => {
  return (
    <>
      <div className="flex items-center">
        <Height />
        <div className="text-[10px] text-semantic-global-text-default">{height}m</div>
      </div>
      <div>{children}</div>
      <div className="flex items-center">
        <Length />
        <div className="text-[10px] text-semantic-global-text-default">{length}m</div>
      </div>
    </>
  )
}

export default Dimensions
